{
  "en": {
    "continueSignIn": {
      "accountSwitch": {
        "title": "Switch account",
        "description": "Your {provider} account is linked to a different fobizz account. Do you want to sign in with that account now?",
        "confirm": "Yes, sign in again",
        "cancel": "Cancel"
      },
      "linkBlocked": {
        "title": "Link account",
        "description": "This account is already linked to a different {provider} account. Please remove the existing link in your settings and restart the process.",
        "confirm": "Go to my settings",
        "cancel": "Cancel"
      },
      "linkAvailable": {
        "title": "Link account",
        "description": "You are logged in with this fobizz account. Would you like to link your {provider} account to it?",
        "confirm": "Yes, use this account",
        "otherAccountsTitle": "More fobizz accounts",
        "signIn": "Use another fobizz account",
        "createNew": "Create a new account",
        "cancel": "Cancel"
      },
      "anonymous": {
        "title": "Continue with {provider} login",
        "description": "Would you like to link an existing fobizz account or create a new one?",
        "signIn": "Sign in and link",
        "createNew": "Create account with {provider} data",
        "cancel": "Cancel"
      },
      "providers": {
        "google_oauth2": "Google",
        "microsoft_office365": "Microsoft",
        "apple": "Apple",
        "bildung_lsa": "Bildung-LSA",
        "edulog": "Edulog",
        "edupool": "Edupool",
        "entree": "Entree Federatie",
        "lux": "Lux",
        "untis": "WebUntis",
        "vidis": "VIDIS",
        "univention": "Univention",
        "austria": "Austria"
      },
      "errors": {
        "emailTaken": "An account with this email address already exists."
      }
    }
  }
}
